export interface CrmTag {
  id: number;
  name: string;
  color: string;
  category: string;
  isActive: boolean;
}

